   <template>
   <div>
	   <b-modal v-model="modalShow" id="modal-lg" class="home-modal" size="lg" hide-footer="true">
			<CovidBanner />
			<!-- <img src="static/commercial/img/MMRemtechAwards.jpg" class="banner-img"  onclick="window.open('https://remtech.org/merchantrade-money-visa-prepaid-card/', '_blank')"> -->
		</b-modal>
     <div class="hero-section">

			<div class="banner-image">
				<img class="landscape-image" src="/static/commercial/img/banner02.png" alt="">
				<img class="portrait-image" src="/static/commercial/img/header-banner01.png" alt="">
			</div>
	<!-- eo banner image -->
<NavHeader/>
	<!-- eo header -->
	

<div class="hero-content business-content">
		<div class="container">
			<div class="left-content">
				<h3>Save On Your Overseas Business Payments </h3>

				<p>Make payments to suppliers in an efficient and secure way. Highly competitive exchange rates, zero sign up fees and efficient processing for fast transfers with low service charge.</p>

				<a href="https://www.bizpayments.com.my/account/register" class="theme-btn">Sign Up Today</a>
			</div>
			<!-- eo left content -->
		</div>
		<!-- eo container -->
	</div>
	<!-- eo hero content -->
	<!-- eo hero content -->
</div>
<!-- eo hero section -->

<div class="divider"></div>

<div class="container">
<div class="text-content-section">
	<h2 class="content-header">Tailored for today's fast-paced Business Environment</h2>

	<p class="content-para">Built with the small and medium businesses in mind, you get the same simple, straight-through process and great benefits, including competitive exchange rates, low service charges, fast transfers and next day payments. 
		<!-- <br><br>Putting your business on the fast track with time-saving, easy-to-track features that takes away the pain of complicated international money transfers when running a fast-paced business. -->
		</p>
	
	<div class="feature">
	<div class="row">
		<div class="col-md-4 feature-list">
			<img src="/static/commercial/img/icons/competitiveERate.png" alt="">
			<h3>Competitive Exchange Rates</h3>
		</div>
		<div class="col-md-4 feature-list">
			<img src="/static/commercial/img/icons/fasttransfer.png" alt="">
			<h3>Fast Transfers</h3>
		</div>
		<div class="col-md-4 feature-list">
			<img src="/static/commercial/img/icons/safesecure.png" alt="">
			<h3>Safe & Secure</h3>
		</div>
	</div>

	<div class="row">
		<div class="col-md-4 feature-list">
			<img src="/static/commercial/img/icons/nextday.png" alt="">
			<h3>Same Day Payments</h3>
			<p>(*Selected countries)</p>
		</div>
		<div class="col-md-4 feature-list">
			<img src="/static/commercial/img/icons/transferlimit.png" alt="">
			<h3>Higher daily transfer limit</h3>
			<p>(up to RM10 million)</p>
		</div>
		<div class="col-md-4 feature-list">
			<img src="/static/commercial/img/icons/servicecharge.png" alt="">
			<h3>Low Service Charge</h3>
		</div>
	</div>
	</div>
	<!-- eo feature -->
</div>
<!-- eo text content section -->
</div>
<!-- eo container -->

<div class="divider"></div>

<div class="coverage">
	<img src="/static/commercial/img/coverage.png" alt="">
	<div class="coverage-content">
		<h3>Worldwide Coverage</h3>
		<p>Indonesia, Philippines, Nepal, Bangladesh, Singapore, Sri Lanka, India, United States, United Kingdom, New Zealand, Australia, Hong Kong, Japan, China, Europe, Canada, Thailand and more</p>
	</div>
</div>

<div class="divider"></div>




<BusinessHorizon/>


</div>
    </template>
    <script>

import BusinessHorizon from "../../shared/commercial/BusinessHorizon.vue";
import NavHeader from "../../shared/commercial/NavHeader.vue";
import CovidBanner from "../../shared/CovidBanner";



export default {
  name: "Business",
  
  components : {BusinessHorizon,NavHeader, CovidBanner},


  created() {},
  data() {
    return {
		modalShow: false,
     vModel: {
        RecipientId: null
      }
    };
  },
  methods: {


  }
};
</script>

